import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const PreserveProfitLine = observer(({
  tradePlanId,
  state,
  priceToBreak,
  amount,
  size,
  scaleY,
  portalRef,
  fillPrice,
  openQuantity,
  priceMultiplier,
  realizedPnl,
  isLong,
  tickSize,
  delta,
}) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
  const paused = tradePlan?.exitTactics['PRESERVE_PROFIT']?.paused ?? null;

  const price = Number(priceToBreak);
  const json = {
    Category: 'Exit Tactic',
    Type: 'Preserve Profit',
    Amount: amount,
  };
  return (
    <>
      {scaleY ? (
        <>
          {paused ? (
            <line
              strokeDasharray={4}
              stroke={state === 'wait' ? colors.orange : colors.red}
              strokeWidth={2}
              x1={0}
              x2={size}
              y1={scaleY(price)}
              y2={scaleY(price)}
            />
          ) : (
            <line
              stroke={state === 'wait' ? colors.orange : colors.red}
              strokeWidth={2}
              x1={0}
              x2={size}
              y1={scaleY(price)}
              y2={scaleY(price)}
            />
          )}

          <HoverBox
            json={json}
            topBoundary={scaleY(price) - 2}
            bottomBoundary={scaleY(price) + 2}
            leftBoundary={0}
            rightBoundary={size}
            portalRef={portalRef}
            size={size}
            linePrice={price}
            tickSize={tickSize}
            fillPrice={fillPrice}
            openQuantity={openQuantity}
            priceMultiplier={priceMultiplier}
            realizedPnl={realizedPnl}
            isLong={isLong}
            delta={delta}
          />
        </>
      ) : null}
    </>
  );
});

PreserveProfitLine.propTypes = {
  state: PropTypes.any,
  priceToBreak: PropTypes.number,
  amount: PropTypes.number,
  size: PropTypes.number,
  scaleY: PropTypes.func,
  portalRef: PropTypes.object,
  tradePlanId: PropTypes.any,
  fillPrice: PropTypes.number,
  openQuantity: PropTypes.number,
  priceMultiplier: PropTypes.number,
  realizedPnl: PropTypes.number,
  isLong: PropTypes.bool,
  tickSize: PropTypes.number,
  delta: PropTypes.number,
};
